import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {LoaderService} from "../../../services/loader.service";
import {ProgramService} from "../../program.service";
import {GlobalErrorHandlerService} from "../../../services/global-error.service";
import {UserService} from "../../../services/user.service";
import {EligiblePatient, ProgramEnrollment} from "../../eligible-patient";
import {Program} from "../../program";
import {Tab} from "../../../tabs/tab";
import {EnrolledPatientComponent} from "../../enrolled-patient/enrolled-patient.component";
import {TabsService} from "../../../services/tabs.service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-program-alert-dashboard',
  templateUrl: './program-alert-dashboard.component.html',
  styleUrls: ['./program-alert-dashboard.component.scss']
})
export class ProgramAlertDashboardComponent implements OnInit, OnDestroy, OnChanges {
  @Input() alertId: string;
  @Output() loaded = new EventEmitter<void>();
  public dateRangeValue: Date[];
  public alerts: [] = [];
  public totalItems;
  public selectedPatient: EligiblePatient;
  public program: Program;
  public selectProgramType: any;
  public enrolled_in: any[];
  @ViewChild('selectTypeFromAlertModal') selectTypeFromAlertModal;
  private initialLoadHandled = false;
  private routeCleared = false;
  private firstLoadDone = false;
  public filter: Object = {name: '',
    page: 1,
    status: 'unresolved',
    severity: 'all',
    from: '',
    to: '',
    no_of_days : 'last_seven_days',
    notification_id: ''};

  constructor(public loaderService: LoaderService, public programService: ProgramService,
              public globalErrorHandlerService: GlobalErrorHandlerService, public userService: UserService,
              public tabsService: TabsService,
              private router: Router,
              private route: ActivatedRoute) {
  }
  ngOnInit(): void {
    this.restartActiveTabTime();
    if (!this.initialLoadHandled) {
      this.handleAlertIdChange();
      this.initialLoadHandled = true;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['alertId']) {
      this.handleAlertIdChange();
      this.initialLoadHandled = true;
    }
  }
  private handleAlertIdChange() {
    if (this.alertId) {
      this.searchFromLink(this.alertId);
    } else {
      this.getAlerts();
    }
  }

  search() {
    this.filter['page'] = 1;
    this.getAlerts();
  }

  searchFromLink(id) {
    this.filter['notification_id'] = id;
    this.search();
  }

  getAlerts() {
    this.loaderService.show();
    this.setFilters();
    this.programService.getAlerts(this.filter).then(resp => {
      this.alerts = resp.alerts;
      this.totalItems = resp.total;
      this.filter['page'] = resp.current_page;
      this.clearRouteIfNeeded();
      if (!this.firstLoadDone) {
        this.firstLoadDone = true;
        this.loaded.emit();
      } else {
        this.loaderService.hide();
      }
    }).catch(resp => {
      this.loaderService.hide();
      this.globalErrorHandlerService.error = resp.error.error;
    });
  }

  private clearRouteIfNeeded() {
    if (this.alertId && !this.routeCleared) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { id: null },
        queryParamsHandling: 'merge'
      });
      this.alertId = null;
      this.routeCleared = true;
    }
  }

  pageChanged($event: any) {
    this.filter['page'] = $event.page;
    this.getAlerts();
  }

  setDateRange(event: Date[]) {
    if (event) {
      this.filter['from'] = String(event[0]);
      this.filter['to'] = String(event[1]);
    }
  }

  setFilters() {
    if (this.filter['no_of_days'] !== 'custom') {
      delete this.filter['from'];
      delete this.filter['to'];
    }
    return this.filter
  }

  openEnrolledPatient(patient: EligiblePatient, program: Program) {
    this.selectedPatient = new EligiblePatient().load_from_json(patient)
    this.program = new Program().load_from_json(program);
    if (this.selectedPatient.enrolled_in.length == 1) {
      this.selectProgramType = this.selectedPatient.enrolled_in[0];
      this.openPatient(this.selectedPatient, this.program);
    } else {
      this.enrolled_in = this.selectedPatient.enrolled_in;
      this.selectProgramType = this.enrolled_in[0];
      this.selectTypeFromAlertModal.show();
    }
  }

  selectProgramTypeToOpen() {
    this.openPatient(this.selectedPatient, this.program);
  }

  openPatient(patient: EligiblePatient, program: Program) {
    this.tabsService.add_tab(new Tab({title: patient.name, icon: 'fa', autorefresh: false}, EnrolledPatientComponent,
      patient.id, {patient: patient,
        program: program,
        programme_type: this.selectProgramType,
        enrolment: patient.tem_programme_enrolment,
        closeOnSwitch: true}))
  }

  closeSelectProgramModel() {
    this.selectTypeFromAlertModal.hide();
    this.selectedPatient = new EligiblePatient();
    this.program = new Program();
    this.selectProgramType = '';

  }
  ngOnDestroy() {
    let tabs: Tab[] = this.tabsService.tabs;
    tabs?.map((tab: Tab) => {
      if (tab.dependencies['enrolment']) {
        let enrolment: ProgramEnrollment = tab.dependencies['enrolment'];
        enrolment.timer.unsubscribe();
      }
    });
  }

  restartActiveTabTime() {
    let tabs: Tab[] = this.tabsService.tabs;
    tabs?.map((tab: Tab) => {
      if (tab.dependencies['enrolment']) {
        let enrolment: ProgramEnrollment = tab.dependencies['enrolment'];
        enrolment.startTimer();
      }
    });
  }
}
